import React, { useEffect } from 'react';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';
import RetencionesMasivasFilesRenderStatus from '../components/RetencionesMasivasFilesRenderStatus';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.files.list;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.files.list;
};

const RetencionesMasivasFilesList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state;

  useEffect(() => {
    if (data.length === 0) {
      paginate({ page: 1 });
    }
  }, []); // eslint-disable-line

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const paginate = (meta) => {
    actions.paginate({ pagination: meta });
  };

  const getPaginationConfig = () => {
    return {
      metadata: state.pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const setSelectedRows = (event) => {
    actions.setSelectedRows(event);

    !!props.onRowSelectionChange && props.onRowSelectionChange(event);
  };

  const getRowSelectionConfig = () => {
    const { selectedRowKeys = [] } = props;

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: setSelectedRows,
      getCheckboxProps: (record) => ({
        name: record.name,
      }),
    };
  };

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      selectable={true}
      pagination={getPaginationConfig()}
      onRow={onRowRender}
      rowSelection={getRowSelectionConfig()}
    ></Table>
  );
};

const onRowRender = (item) => {
  return {
    className: item.highlight ? 'row-highlighted' : '',
  };
};

const columns = [
  {
    key: 'created_at',
    title: 'Fecha',
    dataIndex: 'created_at',
  },
  {
    key: 'filename',
    title: 'Archivo',
    dataIndex: 'filename',
  },
  {
    key: 'tipo',
    title: 'Tipo',
    dataIndex: 'tipo',
    render: (item) => item.tipo.replace('timbrado-', ''),
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    align: 'center',
  },
  {
    key: 'subidos',
    title: 'Subidos',
    dataIndex: 'subidos',
    align: 'center',
  },
  {
    key: 'procesados',
    title: 'Procesados',
    dataIndex: 'procesados',
    align: 'center',
  },
  {
    key: 'timbrados',
    title: 'Timbrados',
    dataIndex: 'timbrados',
    align: 'center',
  },
  {
    key: 'errores',
    title: 'Errores',
    dataIndex: 'errores',
    align: 'center',
  },
  {
    key: 'duplicados',
    title: 'Duplicados',
    dataIndex: 'duplicados',
    align: 'center',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => <RetencionesMasivasFilesRenderStatus item={item} />,
  },
];

export default RetencionesMasivasFilesList;
